import { tapResponse } from '@ngrx/operators';
import { Observable, defaultIfEmpty, firstValueFrom } from 'rxjs';

type TapResponseObserver<T, E> = {
  next: (value: T) => void;
  error: (error: E) => void;
  complete?: () => void;
  finalize?: () => void;
};

export const callApiMethod = <T, E>(
  apiCall: () => Observable<T>,
  responseObserver: TapResponseObserver<T, E>,
) =>
  firstValueFrom(
    apiCall().pipe(tapResponse(responseObserver), defaultIfEmpty(undefined)),
  );
